import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { WorkflowStep } from '@core/models/workflow.model';
import { TranslocoService } from '@ngneat/transloco';

import it from './i18n/plan-steps-procedure-report.it.json';

@Component({
  templateUrl: './plan-steps-procedure-report.component.html',
  styles: [
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanStepsProcedureReportComponent implements OnInit {

  @Input() step!: WorkflowStep;

  constructor(
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnInit(): void {
  }

}
